import { TCreateCompanyReqDto } from "@/api/services/admin/company/dtos/create-company.dto";
import { TGetCompanyDto } from "@/api/services/admin/company/dtos/get-company.dto";
import { TUpdateCompanyReqDto } from "@/api/services/admin/company/dtos/update-company.dto";
import { TGetUserDto } from "@/api/services/admin/company/user/dtos/get-user.dto";
import { DATE_NOT_TIMEZONE_FORMAT } from "@/constants/datetime";
import { TCompanyForm } from "@/features/company/types/companyForm";
import { TCompanyUserForm } from "@/features/company/types/companyUserForm";
import { dayjs } from "@/utils/dayjs";
import { toNumber } from "@/utils/number";

export const convertCompanyFormToCreateReq = (
  data: TCompanyForm,
  organizationId: number | string,
  productContractId: number | string,
): TCreateCompanyReqDto => {
  return {
    companyName: data.companyName,
    contractStatus: data.contractStatus,
    startReportQuarter: data.startReportQuarter ?? null,
    note: data.note ?? null,
    specificIndustryId: toNumber(data.specificIndustryId),
    companyDescription: data.companyDescription ?? null,
    contractStartDate: data.contractStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    contractEndDate: data.contractEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    trialStartDate: data.trialStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    trialEndDate: data.trialEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    startReportYear: data.startReportYear.get("year"),
    pricePerEmployee: data.pricePerEmployee ?? null,
    organizationId: Number(organizationId),
    productContractId: Number(productContractId),
  };
};

export const convertCompanyFormToUpdateReq = (data: TCompanyForm): TUpdateCompanyReqDto => {
  return {
    companyName: data.companyName,
    contractStatus: data.contractStatus,
    specificIndustryId: toNumber(data.specificIndustryId),
    companyDescription: data.companyDescription ?? null,
    contractStartDate: data.contractStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    contractEndDate: data.contractEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    trialStartDate: data.trialStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    trialEndDate: data.trialEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    startReportYear: data.startReportYear.get("year"),
    startReportQuarter: data.startReportQuarter ?? null,
    pricePerEmployee: data.pricePerEmployee ?? null,
    note: data.note ?? null,
  };
};

export const convertCompanyResToForm = (data: TGetCompanyDto): Partial<TCompanyForm> => {
  return {
    companyDescription: data.companyDescription ?? undefined,
    companyName: data.companyName,
    note: data.note ?? undefined,
    contractStatus: data.contractStatus,
    specificIndustryId: data.specificIndustryId.toString(),
    specificBusinessClassificationIds: data.specificBusinessClassificationIds,
    contractEndDate: data.contractEndDate ? dayjs(data.contractEndDate) : undefined,
    contractStartDate: data.contractStartDate ? dayjs(data.contractStartDate) : undefined,
    trialStartDate: data.trialStartDate ? dayjs(data.trialStartDate) : undefined,
    trialEndDate: data.trialEndDate ? dayjs(data.trialEndDate) : undefined,
    startReportQuarter: data.startReportQuarter,
    startReportYear: dayjs().year(data.startReportYear),
    pricePerEmployee: data.pricePerEmployee ?? undefined,
  };
};

export const convertCompanyUserResToForm = (data: TGetUserDto): Partial<TCompanyUserForm> => {
  return {
    email: data.email,
    fullName: data.fullName,
    isCompanyAdmin: Number(data.isCompanyAdmin),
    isCompanyUser: Number(data.isCompanyUser),
    activeStatus: data.activeStatus,
  };
};
